import {ILocalMessage} from '@toolify/client/src/modules/notifications/types/ILocalMessage'
import {MessageSeverityType} from '@toolify/client/src/modules/notifications/enum/MessageSeverityType'
import {MessageStateType} from '@toolify/client/src/modules/notifications/enum/MessageStateType'

// Whether a local message raised while the desktop app is hidden goes native. A running progress goes
// only once it settles into its result.
export function isNativeLocalMessageCandidate(message: ILocalMessage): boolean {
  return message.state !== MessageStateType.Leave
    && message.severity !== MessageSeverityType.Progress
}
